import { useEffect, useRef } from "react";
import { useNavigation } from "react-router";

import { analytics } from "~/analytics";

export function Analytics() {
  const navigation = useNavigation();
  const prevUrlRef = useRef<string | undefined>(undefined);

  // Runs on initial page load
  useEffect(() => {
    prevUrlRef.current = window.location.href;
  }, []);

  // Runs on page navigations
  useEffect(() => {
    if (navigation.state === "idle") {
      const landingPathname = window.location.pathname;
      const referrer = prevUrlRef.current;
      analytics.page({ name: landingPathname, properties: { referrer } });
      prevUrlRef.current = window.location.href;
    }
  }, [navigation]);

  return null;
}
